import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { PendingLegacyCertsData } from "@/hooks/queries/admin-legacy-cert-types";

// GET /admin/legacy-certs?status=pending (Story 16.4, AC8) — the super_admin pending
// verification queue. A post-session data call, so it rides apiFetch's silent-refresh
// path (skipAuthRefresh deliberately omitted). The approve mutation invalidates this
// key on success so a decided row drops out of the queue (AC9).

/** Root key for the pending-cert queue — invalidateQueries(PENDING_CERTS_QUERY_KEY). */
export const PENDING_CERTS_QUERY_KEY = ["admin", "legacy-certs", "pending"] as const;

// Explicit hard cap = the backend's max page size (limit ≤ 100). The queue is a single
// page by design: a manual-approval migration backlog is bounded and far below 100, so
// "Load more" cursors are overkill. The cap is INTENTIONAL, not the silently-discarded
// default-20 — the screen compares `count` against the rendered rows and surfaces a
// notice if the backlog ever exceeds the cap, so nothing is hidden without indication.
// Promote to cursor pagination only if the pending backlog realistically exceeds 100.
export const PENDING_CERTS_PAGE_SIZE = 100;

export function useListPendingLegacyCerts() {
  return useQuery({
    queryKey: PENDING_CERTS_QUERY_KEY,
    queryFn: () =>
      apiFetch<PendingLegacyCertsData>(
        `/admin/legacy-certs?status=pending&limit=${PENDING_CERTS_PAGE_SIZE}`,
      ),
  });
}
